module.exports = __webpack_public_path__ + "img/bg_desktop.234b284c.png";